import { useQuery } from "@tanstack/react-query";
import { getBrands } from "../../api/apiBrands";
import i18next from "i18next";

/**
 * Hook لجلب قائمة العلامات التجارية
 * @param {Object} params - Query parameters (page, per_page, search, is_active)
 */
export function useGetBrands(params = {}) {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["brands", params, i18next.language],
        queryFn: () => getBrands(params),
        retry: false,
    });

    const brands = data?.data || [];
    const meta = data?.meta || { current_page: 1, per_page: params.per_page || 15, total: 0 };

    return { isLoading, error, brands, meta, refetch };
}
